import react from 'react';
import { RiErrorWarningFill } from "react-icons/ri";
import Shared from '../Frame/Shared';

const UnAuthorize=()=>{
    return (
     <Shared pageTitle={<><RiErrorWarningFill size={25} /> خطا</>}>
       خطا در دسترسی شما به وجود آمده ، لطفا از حساب کاربری خود خارج و مجدداً وارد نرم افزار شوید
        </Shared>
    )
}

export default UnAuthorize;